import StoryblokJSClient from 'storyblok-js-client';

const storyblokClient = new StoryblokJSClient({
  accessToken: process.env.REACT_APP_STORYBLOK_ACCESS_TOKEN,
  region: 'eu',
  https: true,
  cache: { type: 'memory', clear: 'auto' },
});

export const getStoryblokClient = () => {
  return storyblokClient;
};

const excludeFields = ['_editable', '_uid', 'short_description'];

export const convertNestedBlokKeys = (blok) => {
  const newBlok = { ...blok };
  let outputObject = {};

  for (let key in newBlok) {
    if (excludeFields.includes(key) || key.startsWith('_')) {
      outputObject[key] = newBlok[key];
      continue;
    }

    let keysSequence = key.split('_');
    if (keysSequence.length > 1) {
      // Create a nested structure based on the keysSequence
      let currentObject = outputObject;
      for (let i = 0; i < keysSequence.length - 1; i++) {
        const currentKey = keysSequence[i];
        if (!currentObject[currentKey]) {
          currentObject[currentKey] = {};
        }
        currentObject = currentObject[currentKey];
      }

      // Assign the value to the deepest key
      const lastKey = keysSequence[keysSequence.length - 1];
      currentObject[lastKey] = newBlok[key];
      delete newBlok[key];
    } else {
      outputObject[key] = newBlok[key];
    }
  }

  for (let key in outputObject) {
    newBlok[key] = outputObject[key];
  }
  return newBlok;
};
